/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
/**
 * A utility function that delays a promise by a minimum duration.
 * This prevents rapid loading state changes that could cause visual flickering.
 *
 * @param promise - The promise to delay.
 * @param ms - The minimum duration to delay the promise. (Default: 500)
 * @returns The delayed promise.
 */
export async function minDelay<T>(promise: Promise<T>, ms = 500): Promise<T> {
  const delay = new Promise((resolve) => setTimeout(resolve, ms));
  const [p] = await Promise.all([promise, delay]);

  return p;
}
